<p-autoComplete placeholder="Search" [(ngModel)]="selectedPhiSearchResult" field="displayName" #phiAutocomplete
                [suggestions]="phiSearchResults" (completeMethod)="phiSearch($event)"
                (onSelect)="phiSelectedFromSearch($event)" [dropdown]="true" dropdownMode="current">
                <!--id="phiAutocomplete" [suggestions]="phiSearchResults" (completeMethod)="phiSearch($event)"-->
    <ng-template let-phi pTemplate="item">
      <div>
        <span style="margin-right: 5px;font-size:.9em" class="pi {{phi.resultType}}"></span><span style="font-size:.9em;white-space:pre-line;" pTooltip="{{phi.memberId}}">{{phi.displayName}}</span>
      </div>
    </ng-template>
  </p-autoComplete>
